<template>
  <div class="option-panel">
    <a-tabs type="card" tab-position="left">
      <a-tab-pane key="contact" :tab="$t('Association')">
        <a-checkbox-group v-model:value="associationSelected" style="width: 100%">
          <a-row>
            <a-col :span="24" v-for="item in associationNameList" :key="item.value">
              <!--            <a-tooltip :title="item.label" placement="right" color="orange">-->
              <a-checkbox :value="item.label">
                <a-popover placement="rightBottom">
                  <template #content>
                    <a-card size="small" :title="$t('anatomyExplained')" style="width: 500px">
                      <template #extra>
<!--                        <sound-two-tone style="cursor:pointer;" @click="playSound(item.explain)"/>-->
                        <play-sound v-if="currentSound !== item.explain" style="cursor:pointer;" @click="playSound(item.explain)"></play-sound>
                        <ban-sound v-else-if="currentSound === item.explain" style="cursor:pointer;" @click="banSound"></ban-sound>
                      </template>
                      {{ $t(item.explain) }}
                    </a-card>
                    <a-card size="small" :title="$t('function')" style="width: 500px">
                      <template #extra>
<!--                        <sound-two-tone style="cursor:pointer;" @click="playSound(item.function)"/>-->
                        <play-sound v-if="currentSound !== item.function" style="cursor:pointer;" @click="playSound(item.function)"></play-sound>
                        <ban-sound v-else-if="currentSound === item.function" style="cursor:pointer;" @click="banSound"></ban-sound>
                      </template>
                      {{ $t(item.function) }}
                    </a-card>
                  </template>
                  <span style="display: inline-block;white-space: nowrap; ">{{ $t(item.name) }}</span>
                </a-popover>
              </a-checkbox>
              <!--            </a-tooltip>-->
            </a-col>
          </a-row>
        </a-checkbox-group>
      </a-tab-pane>
      <a-tab-pane key="project" :tab="$t('Projection')">
        <a-checkbox-group v-model:value="projectionSelected" style="width: 100%">
          <a-row>
            <a-col :span="24" v-for="item in projectionNameList" :key="item.value">
              <!--            <a-tooltip :title="item.label" placement="right" color="orange">-->
              <a-checkbox :value="item.label">
                <a-popover placement="right">
                  <template #content>
                    <a-card size="small" :title="$t('anatomyExplained')" style="width: 500px">
                      <template #extra>
                        <play-sound v-if="currentSound !== item.explain" style="cursor:pointer;" @click="playSound(item.explain)"></play-sound>
                        <ban-sound v-else-if="currentSound === item.explain" style="cursor:pointer;" @click="banSound"></ban-sound>
                      </template>
                      {{ $t(item.explain) }}
                    </a-card>
                    <a-card size="small" :title="$t('function')" style="width: 500px">
                      <template #extra>
                        <play-sound v-if="currentSound !== item.function" style="cursor:pointer;" @click="playSound(item.function)"></play-sound>
                        <ban-sound v-else-if="currentSound === item.function" style="cursor:pointer;" @click="banSound"></ban-sound>
                      </template>
                      {{ $t(item.function) }}
                    </a-card>
                  </template>
                  {{ item.name }}
                </a-popover>
              </a-checkbox>
              <!--            </a-tooltip>-->
            </a-col>
          </a-row>
        </a-checkbox-group>
      </a-tab-pane>
      <a-tab-pane key="united" :tab="$t('Commissural')">
        <a-checkbox-group v-model:value="commissuralSelected" style="width: 100%">
          <a-row>
            <a-col :span="24" v-for="item in commissuralList" :key="item.value">
              <!--            <a-tooltip :title="item.label" placement="right" color="orange">-->
              <a-checkbox :value="item.label">
                <a-popover placement="right">
                  <template #content>
                    <a-card size="small" :title="$t('anatomyExplained')" style="width: 500px">
                      <template #extra>
                        <play-sound v-if="currentSound !== item.explain" style="cursor:pointer;" @click="playSound(item.explain)"></play-sound>
                        <ban-sound v-else-if="currentSound === item.explain" style="cursor:pointer;" @click="banSound"></ban-sound>
                      </template>
                      {{ $t(item.explain) }}
                    </a-card>
                    <a-card size="small" :title="$t('function')" style="width: 500px">
                      <template #extra>
                        <play-sound v-if="currentSound !== item.function" style="cursor:pointer;" @click="playSound(item.function)"></play-sound>
                        <ban-sound v-else-if="currentSound === item.function" style="cursor:pointer;" @click="banSound"></ban-sound>
                      </template>
                      {{ $t(item.function) }}
                    </a-card>
                  </template>
                  {{ item.name }}
                </a-popover>
              </a-checkbox>
              <!--            </a-tooltip>-->
            </a-col>
          </a-row>
        </a-checkbox-group>
      </a-tab-pane>
      <a-tab-pane key="cerebellum" :tab="$t('Cerebellum')">
        <a-checkbox-group v-model:value="cerebellumSelected" style="width: 100%">
          <a-row>
            <a-col :span="24" v-for="item in cerebellumNameList" :key="item.value">
              <!--            <a-tooltip :title="item.label" placement="right" color="orange">-->
              <a-checkbox :value="item.label">
                <a-popover placement="right">
                  <template #content>
                    <a-card size="small" :title="$t('anatomyExplained')" style="width: 500px">
                      <template #extra>
                        <play-sound v-if="currentSound !== item.explain" style="cursor:pointer;" @click="playSound(item.explain)"></play-sound>
                        <ban-sound v-else-if="currentSound === item.explain" style="cursor:pointer;" @click="banSound"></ban-sound>
                      </template>
                      {{ $t(item.explain) }}
                    </a-card>
                    <a-card size="small" :title="$t('function')" style="width: 500px">
                      <template #extra>
                        <play-sound v-if="currentSound !== item.function" style="cursor:pointer;" @click="playSound(item.function)"></play-sound>
                        <ban-sound v-else-if="currentSound === item.function" style="cursor:pointer;" @click="banSound"></ban-sound>
                      </template>
                      {{ $t(item.function) }}
                    </a-card>
                  </template>
                  {{ item.name }}
                </a-popover>
              </a-checkbox>
              <!--            </a-tooltip>-->
            </a-col>
          </a-row>
        </a-checkbox-group>
      </a-tab-pane>
      <a-tab-pane key="Cranial" :tab="$t('CranialNerves')">
        <a-checkbox-group v-model:value="cranialSelected" style="width: 100%">
          <a-row>
            <a-col :span="24" v-for="item in cranialNameList" :key="item.value">
              <!--            <a-tooltip :title="item.label" placement="right" color="orange">-->
              <a-checkbox :value="item.label">
                <a-popover placement="right">
                  <template #content>
                    <a-card size="small" :title="$t('anatomyExplained')" style="width: 500px">
                      <template #extra>
                        <play-sound v-if="currentSound !== item.explain" style="cursor:pointer;" @click="playSound(item.explain)"></play-sound>
                        <ban-sound v-else-if="currentSound === item.explain" style="cursor:pointer;" @click="banSound"></ban-sound>
                      </template>
                      {{ $t(item.explain) }}
                    </a-card>
                    <a-card size="small" :title="$t('function')" style="width: 500px">
                      <template #extra>
                        <play-sound v-if="currentSound !== item.function" style="cursor:pointer;" @click="playSound(item.function)"></play-sound>
                        <ban-sound v-else-if="currentSound === item.function" style="cursor:pointer;" @click="banSound"></ban-sound>
                      </template>
                      {{ $t(item.function) }}
                    </a-card>
                  </template>
                  {{ item.name }}
                </a-popover>
              </a-checkbox>
              <!--            </a-tooltip>-->
            </a-col>
          </a-row>
        </a-checkbox-group>
      </a-tab-pane>
    </a-tabs>
    <a-divider style="border-color: white;margin: 12px 0" dashed/>
    <a-checkbox-group v-model:value="leftRight" style="width: 100%">
      <a-row>
        <a-col :span="8">
        </a-col>
        <a-col :span="8">
          <a-checkbox value="L">{{ $t("left") }}</a-checkbox>
        </a-col>
        <a-col :span="8">
          <a-checkbox value="R">{{ $t("right") }}</a-checkbox>
        </a-col>
      </a-row>
    </a-checkbox-group>
  </div>
</template>

<script>
import util from "@/util/util";
import PlaySound from "@/assets/icon/playSound.vue";
import BanSound from "@/assets/icon/banSound.vue";

export default {
  name: "fibreSelect",
  components: {BanSound, PlaySound},
  props: {
    value: Array
  },
  emits: ['update:value'],
  data() {
    return {
      associationSelected: [],
      projectionSelected: [],
      commissuralSelected: [],
      cerebellumSelected: [],
      cranialSelected: [],
      leftRight: ['L', 'R'],
      audio: new Audio(),
      currentSound : "",
    }
  },
  methods:{
    banSound(){
      this.audio.pause();
      this.currentSound = "";
    },
    async playSound(name) {
      this.currentSound = name;
      this.audio.src = util.personalUrl + "voice/" + name + ".mp3";
      await this.audio.play();
      this.audio.addEventListener('ended', () => {
        this.currentSound = "";
      });

    }
  },
  watch: {
    allSelected() {
      this.$emit("update:value", this.allSelected)
    }
  },
  computed: {
    allSelected() {
      var list = [];
      this.leftRight.map(item => {
        this.associationSelected.map(sel => {
          var filter = this.associationNameList.filter(fil => fil.label === sel)[0];
          if (filter.divide) {
            list.push(sel + "_" + item)
          } else {
            if (!list.includes(sel)) {
              list.push(sel)
            }
          }
        })

        this.projectionSelected.map(sel => {
          var filter = this.projectionNameList.filter(fil => fil.label === sel)[0];
          if (filter.divide) {
            list.push(sel + "_" + item)
          } else {
            if (!list.includes(sel)) {
              list.push(sel)
            }
          }
        })

        this.commissuralSelected.map(sel => {
          var filter = this.commissuralList.filter(fil => fil.label === sel)[0];
          if (filter.divide) {
            list.push(sel + "_" + item)
          } else {
            if (!list.includes(sel)) {
              list.push(sel)
            }
          }
        })

        this.cerebellumSelected.map(sel => {
          var filter = this.cerebellumNameList.filter(fil => fil.label === sel)[0];
          if (filter.divide) {
            list.push(sel + "_" + item)
          } else {
            if (!list.includes(sel)) {
              list.push(sel)
            }
          }
        })

        this.cranialSelected.map(sel => {
          var filter = this.cranialNameList.filter(fil => fil.label === sel)[0];
          if (filter.divide) {
            list.push(sel + "_" + item)
          } else {
            if (!list.includes(sel)) {
              list.push(sel)
            }
          }
        })
      })
      return list;
    },
    associationNameList() {
      return util.associationNameList();
    },
    associationList() {
      return util.associationList();
    },
    projectionNameList() {
      return util.projectionNameList()
    },
    projectionList() {
      return util.projectionList();
    },
    commissuralList() {
      return util.commissuralList();
    },
    cerebellumList() {
      return util.cerebellumList();
    },
    cerebellumNameList() {
      return util.cerebellumNameList();
    },
    cranialList() {
      return util.cranialList();
    },
    cranialNameList() {
      return util.cranialNameList();
    }
  }
}
</script>

<style scoped>

</style>